teeinblue = {
  formSelector: 'product-info product-form form',
  addToCartWrapperSelector: 'product-info product-form form .product-form__buttons',
  formCssSelector: "product-info product-form form .button-cart-compare",
  formEmbedMethod: "css-selector",
  formEmbedType: "before",
  replaceCartItemThumbnail: false,
  autofixerCallback: () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
        fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
        .then(res => res.json())
        .then(res => {
          drawer.renderContents({sections: res});
          const bubbleItem = document.querySelector('.cart-count-bubble.bubble-item');
          if (bubbleItem && bubbleItem.textContent === '0') {
            drawer.classList.add('is-empty');
          }
        });
    }
  },
  openPreview: () => {
    const previewButton = document.querySelector('.tee-btn--preview');
    if (previewButton) {
      previewButton.click();
    }
  },
  getProcessBar: ({ activeGroupIndex, numberOfGroups }) => {
    const stepsTextConfig = window.teeinblue?.stepsText || "Step {current_step} of {total_step}";
    const stepsText = stepsTextConfig
      .replaceAll('{current_step}', `${activeGroupIndex + 1}`)
      .replaceAll('{total_step}', `${numberOfGroups}`);
    const steps = Array.from({ length: numberOfGroups }, (_, i) => {
      return `<li class="step ${i === activeGroupIndex ? 'active' : ''}"></li>`;
    }).join('');
    return `
      <span class="step-text">${stepsText}</span>
      <ul class="steps">${steps}</ul>
      <button class="tee-preview" onClick="window.teeinblue.openPreview()"></button>
    `;
  },
  ...(() => {
    const locale = window.Shopify?.locale;

    if (locale === 'th') {
      return {
        personalizeButtonText: 'ปรับแต่งสินค้าตามสไตล์คุณ',
        nextGroupButtonText: 'ถัดไป',
        backGroupButtonText: 'ย้อนกลับ',
        addtocartButtonText: 'เพิ่มลงในถุงสินค้า',
        modalTitle: 'ปรับแต่งสินค้าตามสไตล์คุณ',
        subTotalText: 'รวมราคา',
        stepsText: 'ขั้นตอนที่ {current_step} จากทั้งหมด {total_step}'

      }
    }

    // The default language is English
    return {
      personalizeButtonText: 'Personalise this item',
      nextGroupButtonText: 'Next Step',
      backGroupButtonText: 'Back',
      addtocartButtonText: 'Add To Bag',
      modalTitle: 'Personalise this item',
      subTotalText: 'Subtotal',
      stepsText: 'Step {current_step} of {total_step}',
    }
  })(),
}

const validate = () => {
  var showMes = false;
  var optionSelectNameError = '';

  const options = document.querySelectorAll('.tpt-swatches-group .product-form__input');

  options.forEach((option) => {
      const optionSelected = option.querySelectorAll('[type="radio"]:checked');
      if (!optionSelected.length) {
          optionSelectNameError = option.closest('.product-form__input').querySelector('.form__label .form__label-name').textContent;

          showMes = true;
          return;
      } else {
          showMes = false;
          return;
      }
  });

  if (showMes) {
      const tptMess = document.getElementById('tpt-mess');

      if (tptMess.classList.contains('show')) {
          clearTimeout(mesTimeout);
      }

      const messText = window.variant_select.error;
      document.getElementById('tpt-mess__text').innerHTML = messText + optionSelectNameError.toLowerCase();

      tptMess.classList.add('tpt-mess__type-error', 'show');

      mesTimeout = setTimeout(() => {
          tptMess.classList.remove('show');
      }, 4000);
  }

  return !showMes;
}

document.addEventListener('click', function (e) {
  const target = e.target;
  const personalizeBtn = target.closest('button.tee-btn--personalize');
  
  if (personalizeBtn && !validate()) {
    e.preventDefault();
    e.stopPropagation();
  }
}, true);

document.addEventListener('DOMContentLoaded', function() {
  document.documentElement.style.setProperty('--personalize-modal-title', `"${window.teeinblue?.modalTitle}"` || '"Personalise this item"');

  const parsePrice = (text) => {
    const match = text.match(/฿\s?([\d,]+)/);
    return match ? parseFloat(match[1].replace(/,/g, '')) : 0;
  }

  const updateTotalPrice = () => {
    const priceSpan = document.querySelector('.product-price--value');
    if (!priceSpan) return;

    // Store the original price (only once)
    if (!priceSpan.dataset.originalPrice || priceSpan.dataset.originalPrice === "0") {
      const base = parsePrice(priceSpan.textContent);
      priceSpan.dataset.originalPrice = base;
    }

    const basePrice = parseFloat(priceSpan.dataset.originalPrice);
    const addonsDiv = document.querySelector('.tee-price-addons');
    const addonPrice = addonsDiv ? parsePrice(addonsDiv.textContent) : 0;

    const total = basePrice + addonPrice;
    const formatted = `฿ ${total.toLocaleString()}`;

    // Prevent infinite loop: only update if different
    if (priceSpan.textContent.trim() !== formatted) {
      priceSpan.textContent = formatted;
    }
  }

  const addPriceToPersonalizePoup = (target) => {
    let pirce = '';
    const priceEl = document.querySelector('.price-item--regular');
    if (priceEl) {
      price = priceEl.textContent;
    }
    const subTotalText = window.teeinblue?.subTotalText || 'Subtotal';
    const htmlToInsert = `
      <div class="tee-edit-popup--product-price">
        <span class="product-price--title">${subTotalText}</span>
        <span class="product-price--value">${price}</span>
      </div>
    `;
    target.insertAdjacentHTML("afterbegin", htmlToInsert);
  }

  const scrollToBottom = () => {
    const dialogBody = document.querySelector('.tee-edit-popup > .vm--modal > .tee-dialog-inner > .tee-dialog-body');
    if (dialogBody) {
      dialogBody.scrollTo({
        top: dialogBody.scrollHeight,
        behavior: 'smooth'
      });
    }
  }

  const observer = new MutationObserver((mutations, obs) => {
    const target = document.querySelector(".tee-edit-popup .tee-form-atc-wrapper");
    const subtotal = document.querySelector(".tee-edit-popup--product-price");
    if (target && !subtotal) {
      addPriceToPersonalizePoup(target)
    }

    if (subtotal) {
      updateTotalPrice();
    }

    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;

        if (node.matches && node.matches('.tee-form-responses')) {
          const teeError = node.querySelector('.tee-error');
          if (teeError) {
            scrollToBottom();
            return;
          }
        }
      }
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }


  const handleInput = (e) => {
    const grandparent = e.target.parentElement?.parentElement;
    const grandparentClasses = Array.from(grandparent?.classList || []).filter(cls => cls !== 'tee-field');
    const matchingElements = Array.from(document.querySelectorAll('.tee-field'))
      .filter(el => el !== grandparent && grandparentClasses.some(cls => el.classList.contains(cls)))
      .filter(el => el.querySelector('select.tee-field__select'));

    const addonChargeData = {};
    matchingElements.forEach((el, elIndex) => {
      const select = el.querySelector('select.tee-field__select');
      if (select) {
        const layerId = select.id;
        const options = select.options;
        let value = null;
        for (let i = 0; i < options.length; i++) {
          if (options[i].text?.toLowerCase() === e.target.value[elIndex]?.toLowerCase()) {
            value = options[i].value;
            break;
          }
        }
        addonChargeData[layerId] = value;
      }
    });

    const pId = window.teeinblueCampaign?.productId;
    if (pId) {
      let customizations = localStorage.getItem('teeinblue-customizations');
      customizations = customizations ? JSON.parse(customizations) : [];
      const cIndex = customizations.findIndex(c => c.productId == pId);
      if (cIndex > -1) {
        customizations[cIndex].customization = {
          ...customizations[cIndex].customization,
          ...addonChargeData,
          [e.target.id]: e.target.value
        }
        localStorage.setItem('teeinblue-customizations', JSON.stringify(customizations));
        window.teeinblue.refillCustomization(pId);
      }
    }
  };

  const debouncedHandleInput = debounce((e) => handleInput(e), 500);

  // Clean up after paste or input
  document.addEventListener('input', function(e) {
    if (e.target.matches('.letters-only .tee-field__input > input')) {
      e.target.value = e.target.value.replace(/[^a-zA-Z\-\. ]/g, '');
    }

    if (e.target.matches('.tee-field__input > input')) {
      debouncedHandleInput(e);
    }
  });

  // Block invalid keys
  document.addEventListener('keydown', function(e) {
    if (e.target.matches('.letters-only .tee-field__input > input')) {
      const allowedKeys = /^[a-zA-Z\-\. ]$/;
      if (!allowedKeys.test(e.key) && e.key.length === 1) {
        e.preventDefault();
      }
    }
  });

  // Prevent paste if it contains invalid characters
  document.addEventListener('paste', function(e) {
    if (e.target.matches('.letters-only .tee-field__input > input')) {
      const pasted = e.clipboardData.getData('text');
      if (/[^a-zA-Z\-\. ]/.test(pasted)) {
        e.preventDefault();
      }
    }
  });

  // Prevent drag-and-drop into input
  document.addEventListener('drop', function(e) {
    if (e.target.matches('.letters-only .tee-field__input > input')) {
      e.preventDefault();
    }
  });

  document.addEventListener('teeinblue-event-after-cart-added', () => {
    const drawer = document.querySelector('cart-drawer');
    window.teeinblue?.removeCustomization?.(window.teeinblueCampaign?.productId)
    if (drawer) {
        fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
        .then(res => res.json())
        .then(res => {
          document.querySelector('.tee-dialog-close').click();
          drawer.renderContents({sections: res});
        });
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    }
  });

  window.addEventListener('keyup', function (e) {
    if (event.which === 27) { // 27 is Escape key
      const modals = document.querySelectorAll('.vm--modal');
      if (modals.length > 0) {
        e.stopImmediatePropagation();

        const topModal = modals[modals.length - 1];
        const closeBtn = topModal.querySelector('.tee-dialog-close');
        if (closeBtn) {
          closeBtn.click();
        }
      }
    }
  }, true);

  window.addEventListener('keydown', function (e) {
    if (e.which === 39) { // 39 is arrow right key
      const teeNextSlideButton = document.querySelector('.tee-slider__button--next');
      if (teeNextSlideButton) {
        e.stopImmediatePropagation();
        teeNextSlideButton.click();
      }
    }

    if (e.which === 37) { // 37 is arrow left key
      const teePrevSlideButton = document.querySelector('.tee-slider__button--prev');
      if (teePrevSlideButton) {
        e.stopImmediatePropagation();
        teePrevSlideButton.click();
      }
    }
  }, true);
});
